import Router from 'svelte-easyroute';
import { navigationStore } from './stores';

import Main from './pages/main/Main.svelte';
import Product from './pages/product/Product.svelte';
import AboutUs from './pages/about-us/AboutUs.svelte';
import Installation from './pages/installation/Installation.svelte';
import TermsOfUse from './pages/terms-of-use/TermsOfUse.svelte';
import SupportMain from './pages/support/SupportMain.svelte';
import SupportFAQ from './pages/support/SupportFAQ.svelte';

const router = new Router({
  mode: 'history', // "hash" or "history"
  routes: [
    {
      path: '/',
      component: Main,
      name: 'index',
    },
    {
      path: '/product',
      component: Product,
      name: 'product',
    },
    {
      path: '/installation',
      component: Installation,
      name: 'installation',
    },
    {
      path: '/about',
      component: AboutUs,
      name: 'about',
    },
    {
      path: '/terms',
      component: TermsOfUse,
      name: 'terms',
    },
    {
      path: '/support',
      component: SupportMain,
      name: 'support',
    },
  ]
});

router.afterEach = (to, from) => {
  const { location: { hash = '' } = {}} = window || {};

  navigationStore.merge({ to: { ...to, hash }, from, router });

  if (!env.PRODUCTION) {
    console.log({ to: { ...to, hash }, from, router });
  }
};

export default router;
